import React, { useEffect, useState } from "react";
import { Grid, Segment, Dimmer } from 'semantic-ui-react';
import ReconDashboard from "./Reconciliation_Dashboard/index";
import { SquareLoader } from "kx-common-components";

const Recon = (props) => {
  const [loading, setLoading] = useState(false);
  useEffect(()=>{
    setTimeout(()=>{
      setLoading(true)
    },3000)
  })
  return ( 
    <Grid columns={1} className="recon-dashboard-grid">
      <Grid.Row>
        <Grid.Column>
          {
            !loading && 
            <Segment className="page-loader">
            <Dimmer active inverted>
              <SquareLoader
                color1={"#1fa2ff"}
                color2={"#12d8fa"}
                color3={"#06ffcb"}
                string={"Preparing Recon Shipments"}
              />
            </Dimmer>
          </Segment>
        }
          <ReconDashboard />        
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
 
export default Recon;